import Pacientes from "./PacientesContainer";

export default Pacientes;
